// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3Hw0R","balanceDisclaimer":"posDashboard_balanceDisclaimer__qqTLu"};